<div class="container-range">
  <mat-label *ngIf="translatedTitle" class="container-range__label">{{ translatedTitle }}</mat-label>
  <mat-form-field appearance="outline">
    <mat-date-range-input [formGroup]="range" [rangePicker]="picker" [max]="maxDate">
      <input
        matStartDate
        formControlName="start"
        [placeholder]="'DATES.inicio' | translate"
        (click)="picker.open()"
        (focus)="picker.open()"
        readonly>
      <input
        matEndDate
        formControlName="end"
        [placeholder]="'DATES.fin' | translate"
        (click)="picker.open()"
        (focus)="picker.open()"
        readonly>
    </mat-date-range-input>
    <mat-hint>DD/MM/YYYY – DD/MM/YYYY</mat-hint>
    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-date-range-picker #picker (closed)="onDatePickerClosed()"></mat-date-range-picker>

    <mat-error *ngIf="range.controls['start'].hasError('matStartDateInvalid')">{{ 'DATES.Fecha de inicio inválida' | translate }}</mat-error>
    <mat-error *ngIf="range.controls['end'].hasError('matEndDateInvalid')">{{ 'DATES.Fecha de fin inválida' | translate }}</mat-error>
  </mat-form-field>
</div>
